export function SunMark({ className = "w-5 h-5" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8.5 20.5a7.5 7.5 0 0 1 15 0"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <line
        x1="3.5"
        y1="23.5"
        x2="28.5"
        y2="23.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="16" y1="5.5" x2="16" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="7.2" y1="8.2" x2="9.4" y2="10.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="24.8" y1="8.2" x2="22.6" y2="10.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ dark = false, tagline = true }) {
  return (
    <span className="inline-flex items-center gap-3">
      <SunMark className={`w-7 h-7 ${dark ? "text-gold" : "text-gold"}`} />
      <span className="leading-tight">
        <span
          className={`block font-serif font-bold text-[16px] sm:text-[18px] ${
            dark ? "text-ivory" : "text-navy"
          }`}
        >
          From Diagnosis to Goodbye
          <sup className="align-super text-[0.55em] font-normal">™</sup>
        </span>
        {tagline && (
          <span
            className={`block text-[10px] sm:text-[11px] uppercase tracking-[0.18em] ${
              dark ? "text-ivory/60" : "text-mist"
            }`}
          >
            Chaplain Derrick Hall
          </span>
        )}
      </span>
    </span>
  );
}
